export var isUrl = function (text) {
    var pattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
    return pattern.test(text);
};
//# sourceMappingURL=is-url.js.map